import { gql } from '@apollo/client';

export const GET_EMAILS_BY_PERIOD_ID = gql`
  query EMAIL_SERVICE_getEmailsByPeriodId($periodId: String!) {
    getEmailsByPeriodId(periodId: $periodId) {
      emailId
      emailAddress
      enrollmentPeriodId
      status
      userType
    }
  }
`;

export const GET_EMAILS_BY_PERIOD_IDS = gql`
  query EMAIL_SERVICE_getEmailsByPeriodIds($periodIds: [String!]!) {
    getEmailsByPeriodIds(periodIds: $periodIds) {
      emailId
      emailAddress
      enrollmentPeriodId
      status
      userType
    }
  }
`;

export const GET_EMAILS_BY_RANGE = gql`
  query EMAIL_SERVICE_getEmailsByRange(
    $from: String!
    $to: String!
    $domainId: String = ""
    $emailType: String = ""
    $status: Status = null
    $page: Int = 1
    $email: String = ""
  ) {
    getEmailsByRange(
      from: $from
      to: $to
      domainId: $domainId
      emailType: $emailType
      page: $page
      status: $status
      email: $email
    ) {
      result {
        id
        domainId
        emailType
        status
        creationDateTime
        userTypes
        emailAddress
        reason
      }
      totalElements
      currentPage
      totalPages
    }
  }
`;

export const GET_EMAIL_TYPES = gql`
  query EMAIL_SERVICE_getEmailTypes {
    getEmailTypes
  }
`;

export const GET_SEND_GRID_CONTEXT = gql`
  query EMAIL_SERVICE_getSendGridContext($id: String!) {
    getSendGridContext(id: $id) {
      templateId
      templateData
      toEmailAddresses
      from
    }
  }
`;

export const GET_CONFIGURABLE_EMAILS = gql`
  query EMAIL_SERVICE_getConfigurableEmails {
    getConfigurableEmails
    getConfigurableEmailsForUser
  }
`;

export const SAVE_CONFIGURABLE_EMAILS_FOR_USER = gql`
  mutation EMAIL_SERVICE_saveConfigurableEmailsForUser($emailTypes: [String]) {
    saveConfigurableEmailsForUser(emailTypes: $emailTypes)
  }
`;
